import { useI18n } from "../i18n";

const CATEGORIES = [
  "Office Supplies",
  "Industrial Equipment",
  "Electronics",
  "Textiles & Apparel",
  "Food & Beverage",
  "Construction Materials",
  "Chemicals",
  "Machinery",
  "Packaging",
  "Other",
];

export const CategoryFilter = ({ selected, onSelect, counts = {} }) => {
  const { t } = useI18n();
  const total = Object.values(counts).reduce((a, b) => a + b, 0);

  return (
    <aside className="w-full lg:sticky lg:top-24">
      <div className="hidden lg:block text-[10px] tracking-[0.2em] uppercase font-bold text-muted-foreground mb-4">
        {t("filters")}
      </div>

      {/* Desktop vertical list */}
      <div className="hidden lg:flex flex-col gap-1">
        <button
          data-testid="filter-all"
          onClick={() => onSelect("all")}
          className={`text-left px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-200 flex items-center justify-between min-h-[44px] ${
            selected === "all"
              ? "bg-foreground text-background"
              : "hover:bg-secondary text-foreground"
          }`}
        >
          <span>{t("filter_all")}</span>
          <span className="font-mono-brand text-xs opacity-60">{total}</span>
        </button>
        {CATEGORIES.map((cat) => (
          <button
            key={cat}
            data-testid={`filter-${cat.replace(/\s+/g, "-").toLowerCase()}`}
            onClick={() => onSelect(cat)}
            className={`text-left px-3 py-2.5 rounded-md text-sm font-medium transition-colors duration-200 flex items-center justify-between min-h-[44px] ${
              selected === cat
                ? "bg-foreground text-background"
                : "hover:bg-secondary text-foreground"
            }`}
          >
            <span className="truncate">{cat}</span>
            <span className="font-mono-brand text-xs opacity-60 ml-2">{counts[cat] || 0}</span>
          </button>
        ))}
      </div>

      {/* Mobile horizontal chip scroller */}
      <div className="lg:hidden -mx-3 sm:-mx-6">
        <div className="flex gap-2 overflow-x-auto scrollbar-none px-3 sm:px-6 py-1 snap-x snap-mandatory">
          <button
            data-testid="filter-all-mobile"
            onClick={() => onSelect("all")}
            className={`shrink-0 snap-start rounded-full px-3.5 h-9 text-xs font-semibold whitespace-nowrap flex items-center gap-1.5 transition-colors ${
              selected === "all"
                ? "bg-foreground text-background"
                : "bg-white border border-border text-foreground"
            }`}
          >
            {t("filter_all")}
            <span className="font-mono-brand text-[10px] opacity-70">{total}</span>
          </button>
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              data-testid={`filter-mobile-${cat.replace(/\s+/g, "-").toLowerCase()}`}
              onClick={() => onSelect(cat)}
              className={`shrink-0 snap-start rounded-full px-3.5 h-9 text-xs font-semibold whitespace-nowrap flex items-center gap-1.5 transition-colors ${
                selected === cat
                  ? "bg-foreground text-background"
                  : "bg-white border border-border text-foreground"
              }`}
            >
              {cat}
              <span className="font-mono-brand text-[10px] opacity-70">{counts[cat] || 0}</span>
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
};

export { CATEGORIES };
